var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 100,
    viewBox: "0 0 135 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "done/rafiki"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M134.605 87.8779H0.398438V87.945H134.605V87.8779Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M121.155 92.1973H112.266V92.2644H121.155V92.1973Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.3013 92.9268H86.9688V92.9939H89.3013V92.9268Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M112.002 89.7061H106.852V89.7732H112.002V89.7061Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.0693 90.1572H14.4766V90.2243H26.0693V90.1572Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.16 90.1572H28.4609V90.2243H30.16V90.1572Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.8324 91.29H35.6875V91.3571H60.8324V91.29Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.0141 75.9071H12.1862C11.7802 75.9064 11.391 75.7446 11.1042 75.4573C10.8174 75.1699 10.6562 74.7805 10.6563 74.3745V1.51922C10.6598 1.11553 10.8224 0.72954 11.1089 0.445087C11.3954 0.160634 11.7825 0.000691535 12.1862 0H64.0141C64.4206 0 64.8104 0.161474 65.0978 0.448899C65.3853 0.736324 65.5467 1.12616 65.5467 1.53264V74.3745C65.5467 74.781 65.3853 75.1708 65.0978 75.4582C64.8104 75.7456 64.4206 75.9071 64.0141 75.9071ZM12.1862 0.0536827C11.798 0.0543938 11.4259 0.209111 11.1516 0.483875C10.8774 0.758639 10.7234 1.131 10.7234 1.51922V74.3745C10.7234 74.7627 10.8774 75.1351 11.1516 75.4098C11.4259 75.6846 11.798 75.8393 12.1862 75.84H64.0141C64.4026 75.8393 64.7749 75.6847 65.0496 75.41C65.3243 75.1353 65.4789 74.7629 65.4796 74.3745V1.51922C65.4789 1.13075 65.3243 0.758398 65.0496 0.483711C64.7749 0.209024 64.4026 0.0543923 64.0141 0.0536827H12.1862Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M122.074 75.9071H70.2436C69.8373 75.9064 69.4479 75.7447 69.1606 75.4574C68.8734 75.1702 68.7116 74.7807 68.7109 74.3745V1.51922C68.7152 1.11529 68.8784 0.729298 69.1653 0.444919C69.4522 0.16054 69.8396 0.000683993 70.2436 0H122.074C122.477 0.00139695 122.864 0.161651 123.15 0.446029C123.436 0.730406 123.598 1.11599 123.601 1.51922V74.3745C123.601 74.78 123.441 75.169 123.154 75.4563C122.868 75.7436 122.48 75.9057 122.074 75.9071ZM70.2436 0.0536827C69.8551 0.0543923 69.4828 0.209024 69.2081 0.483711C68.9334 0.758398 68.7788 1.13075 68.778 1.51922V74.3745C68.7788 74.7629 68.9334 75.1353 69.2081 75.41C69.4828 75.6847 69.8551 75.8393 70.2436 75.84H122.074C122.463 75.8393 122.835 75.6847 123.11 75.41C123.384 75.1353 123.539 74.7629 123.54 74.3745V1.51922C123.539 1.13075 123.384 0.758398 123.11 0.483711C122.835 0.209024 122.463 0.0543923 122.074 0.0536827H70.2436Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.5463 2.88574H25.4219V67.7638H44.5463V2.88574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41.7007 2.88574H40.5841L33.9141 67.7638H35.0307L41.7007 2.88574Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.2144 3.13477H25.3047V3.70648H44.2144V3.13477Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.2144 67.1943H25.3047V68.4183H44.2144V67.1943Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.8995 68.3643H26.0312V68.4179H43.8995V68.3643Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M26.0319 3.13556H43.9002V68.3652H44.9711V2.33301H24.9609V68.3652H26.0319V3.13556Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M65.8354 2.88574H46.7109V67.7638H65.8354V2.88574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M60.5235 2.88574H54.4279L47.7578 67.7638H53.8535L60.5235 2.88574Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M66.0325 3.13477H46.5859V3.70648H66.0325V3.13477Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M66.0325 67.1943H46.5859V68.4183H66.0325V67.1943Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M65.1808 68.3643H47.3125V68.4179H65.1808V68.3643Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M47.3132 3.13556H65.1814V68.3652H66.2497V2.33301H46.2422V68.3652H47.3132V3.13556Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M86.572 2.88574H67.9844V67.7638H86.572V2.88574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M78.521 2.88574H77.4044L70.7344 67.7638H71.851L78.521 2.88574Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M86.7769 3.13477H67.8672V3.70648H86.7769V3.13477Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M86.7769 67.1943H67.8672V68.4183H86.7769V67.1943Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M86.462 68.3643H68.5938V68.4179H86.462V68.3643Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M68.5944 3.13556H86.46V68.3652H87.531V2.33301H67.5234V68.3652H68.5944V3.13556Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M108.398 2.88574H89.2734V67.7638H108.398V2.88574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M106.526 2.88574H100.431L93.7578 67.7638H99.8562L106.526 2.88574Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M108.058 3.13477H89.1484V3.70648H108.058V3.13477Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M108.058 67.1943H89.1484V68.4183H108.058V67.1943Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M89.873 3.13556H107.741V68.3652H108.812V2.33301H88.8047V68.3652H89.873V3.13556Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M107.743 68.3643H89.875V68.4179H107.743V68.3643Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M39.9739 52.8398H31.6719V67.1972H39.9739V52.8398Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M38.3789 50.832V54.4341H37.7267H33.9206H33.2656V50.832H38.3789Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M38.3746 54.4336H39.4375V53.3707H38.3746V54.4336Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M36.3199 54.4346H37.3828V53.3717H36.3199V54.4346Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M34.2652 54.4336H35.3281V53.3707H34.2652V54.4336Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M32.2027 54.4336H33.2656V53.3707H32.2027V54.4336Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M38.3746 56.3643H39.4375V55.3013H38.3746V56.3643Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M36.3199 56.3643H37.3828V55.3013H36.3199V56.3643Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M34.2652 56.3643H35.3281V55.3013H34.2652V56.3643Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M32.2027 56.3643H33.2656V55.3013H32.2027V56.3643Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M38.3746 58.2969H39.4375V57.234H38.3746V58.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M36.3199 58.2969H37.3828V57.234H36.3199V58.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M34.2652 58.2969H35.3281V57.234H34.2652V58.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M36.3199 52.7646H37.3828V51.7017H36.3199V52.7646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M34.2652 52.7646H35.3281V51.7017H34.2652V52.7646Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M32.2027 58.2969H33.2656V57.234H32.2027V58.2969Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M38.3746 60.2285H39.4375V59.1656H38.3746V60.2285Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M36.3199 60.2285H37.3828V59.1656H36.3199V60.2285Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M34.2652 60.2285H35.3281V59.1656H34.2652V60.2285Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M32.2027 60.2285H33.2656V59.1656H32.2027V60.2285Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M38.3746 62.1621H39.4375V61.0992H38.3746V62.1621Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M36.3199 62.1621H37.3828V61.0992H36.3199V62.1621Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M34.2652 62.1621H35.3281V61.0992H34.2652V62.1621Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M32.2027 62.1621H33.2656V61.0992H32.2027V62.1621Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M38.3746 64.0918H39.4375V63.0289H38.3746V64.0918Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M36.3199 64.0918H37.3828V63.0289H36.3199V64.0918Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M34.2652 64.0918H35.3281V63.0289H34.2652V64.0918Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M32.2027 64.0918H33.2656V63.0289H32.2027V64.0918Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M38.3746 66.0244H39.4375V64.9615H38.3746V66.0244Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M36.3199 66.0244H37.3828V64.9615H36.3199V66.0244Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M34.2652 66.0244H35.3281V64.9615H34.2652V66.0244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M32.2027 66.0244H33.2656V64.9615H32.2027V66.0244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M98.4612 58.0684H91.0234V67.1944H98.4612V58.0684Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M91.6719 59.083H93.4005H93.8782H94.3533V60.0332H93.8782H93.4005H91.6719V59.083Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M91.6719 60.9268H93.4005H93.8782H94.3533V61.8796H93.8782H93.4005H91.6719V60.9268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M91.6719 62.7705H93.4005H93.8782H94.3533V63.7234H93.8782H93.4005H91.6719V62.7705Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M91.6719 64.6152H93.4005H94.1359H94.3533V65.5681H94.1359H93.4005H91.6719V64.6152Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M95.1328 59.083H96.8641H97.3392H97.8143V60.0332H97.3392H96.8641H95.1328V59.083Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M95.1328 60.9268H96.8641H97.5351H97.8143V61.8796H97.5351H96.8641H95.1328V60.9268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M95.1328 62.7705H96.8641H97.3392H97.8143V63.7234H97.3392H96.8641H95.1328V62.7705Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M95.1328 64.6152H96.8641H97.3392H97.8143V65.5681H97.3392H96.8641H95.1328V64.6152Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M62.618 61.5254H55.8594V67.197H62.618V61.5254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M61.3232 63.0986H62.1875V62.2343H61.3232V63.0986Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M59.6513 63.0986H60.5156V62.2343H59.6513V63.0986Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M57.9716 63.0986H58.8359V62.2343H57.9716V63.0986Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M56.2998 63.0986H57.1641V62.2343H56.2998V63.0986Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M61.3232 64.6689H62.1875V63.8047H61.3232V64.6689Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M59.6513 64.6689H60.5156V63.8047H59.6513V64.6689Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M57.9716 64.6689H58.8359V63.8047H57.9716V64.6689Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M56.2998 64.6689H57.1641V63.8047H56.2998V64.6689Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M61.3232 66.2412H62.1875V65.3769H61.3232V66.2412Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M59.6513 66.2412H60.5156V65.3769H59.6513V66.2412Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M57.9716 66.2412H58.8359V65.3769H57.9716V66.2412Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M56.2998 66.2412H57.1641V65.3769H56.2998V66.2412Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M54.9461 57.333H48.1875V67.1972H54.9461V57.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M54.5106 57.7646H51.9688V60.2018H54.5106V57.7646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M51.1591 57.7646H48.6172V60.2018H51.1591V57.7646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M54.5106 60.9082H51.9688V63.3454H54.5106V60.9082Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M51.1591 60.9082H48.6172V63.3454H51.1591V60.9082Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M54.5106 64.0518H51.9688V66.4889H54.5106V64.0518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M51.1591 64.0518H48.6172V66.4889H51.1591V64.0518Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M67.5036 100.001C96.2459 100.001 119.546 98.6403 119.546 96.9623C119.546 95.2842 96.2459 93.9238 67.5036 93.9238C38.7612 93.9238 15.4609 95.2842 15.4609 96.9623C15.4609 98.6403 38.7612 100.001 67.5036 100.001Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sheet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M119.728 6.60547V65.7207L112.615 72.8336H71.4375V6.60547H119.728Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    opacity: 0.8,
    d: "M119.728 6.60547V65.7207L112.615 72.8336H71.4375V6.60547H119.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    opacity: 0.2,
    d: "M112.617 72.8333V65.9297H119.73L112.757 72.903",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    opacity: 0.1,
    d: "M89.7121 12.3472H76.3934C76.2062 12.3472 76.0267 12.2728 75.8943 12.1404C75.7619 12.008 75.6875 11.8284 75.6875 11.6412C75.6872 11.5483 75.7052 11.4562 75.7405 11.3703C75.7758 11.2843 75.8277 11.2062 75.8933 11.1403C75.9589 11.0745 76.0368 11.0223 76.1227 10.9866C76.2085 10.951 76.3005 10.9326 76.3934 10.9326H89.7121C89.8996 10.9333 90.0791 11.0083 90.2114 11.1411C90.3437 11.2739 90.418 11.4538 90.418 11.6412C90.418 11.8284 90.3436 12.008 90.2113 12.1404C90.0789 12.2728 89.8993 12.3472 89.7121 12.3472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    opacity: 0.1,
    d: "M113.868 18.0747H81.7606C81.6677 18.0747 81.5757 18.0563 81.4899 18.0207C81.404 17.9851 81.3261 17.9328 81.2605 17.867C81.1949 17.8011 81.143 17.723 81.1077 17.6371C81.0723 17.5511 81.0543 17.459 81.0547 17.3661C81.0547 17.1789 81.1291 16.9993 81.2615 16.8669C81.3938 16.7345 81.5734 16.6602 81.7606 16.6602H113.868C114.055 16.6602 114.235 16.7345 114.367 16.8669C114.5 16.9993 114.574 17.1789 114.574 17.3661C114.574 17.5536 114.5 17.7334 114.368 17.8662C114.235 17.999 114.056 18.074 113.868 18.0747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    opacity: 0.1,
    d: "M113.869 20.8579H76.3934C76.2062 20.8579 76.0267 20.7835 75.8943 20.6511C75.7619 20.5187 75.6875 20.3392 75.6875 20.152C75.6872 20.059 75.7052 19.967 75.7405 19.881C75.7758 19.795 75.8277 19.7169 75.8933 19.6511C75.9589 19.5852 76.0368 19.533 76.1227 19.4974C76.2085 19.4617 76.3005 19.4434 76.3934 19.4434H113.869C114.057 19.4441 114.236 19.519 114.369 19.6519C114.501 19.7847 114.575 19.9645 114.575 20.152C114.575 20.3392 114.501 20.5187 114.368 20.6511C114.236 20.7835 114.056 20.8579 113.869 20.8579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    opacity: 0.1,
    d: "M113.869 24.0044H76.3934C76.3005 24.0044 76.2085 23.986 76.1227 23.9504C76.0368 23.9147 75.9589 23.8625 75.8933 23.7967C75.8277 23.7308 75.7758 23.6527 75.7405 23.5667C75.7052 23.4808 75.6872 23.3887 75.6875 23.2958C75.6875 23.1085 75.7619 22.929 75.8943 22.7966C76.0267 22.6642 76.2062 22.5898 76.3934 22.5898H113.869C114.056 22.5898 114.236 22.6642 114.368 22.7966C114.501 22.929 114.575 23.1085 114.575 23.2958C114.575 23.4832 114.501 23.6631 114.369 23.7959C114.236 23.9287 114.057 24.0037 113.869 24.0044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    opacity: 0.1,
    d: "M113.869 27.1472H76.3934C76.2062 27.1472 76.0267 27.0728 75.8943 26.9404C75.7619 26.8081 75.6875 26.6285 75.6875 26.4413C75.6875 26.2541 75.7619 26.0745 75.8943 25.9421C76.0267 25.8097 76.2062 25.7354 76.3934 25.7354H113.869C114.056 25.7354 114.236 25.8097 114.368 25.9421C114.501 26.0745 114.575 26.2541 114.575 26.4413C114.575 26.6285 114.501 26.8081 114.368 26.9404C114.236 27.0728 114.056 27.1472 113.869 27.1472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    opacity: 0.1,
    d: "M113.869 30.2927H76.3934C76.2062 30.2927 76.0267 30.2183 75.8943 30.086C75.7619 29.9536 75.6875 29.774 75.6875 29.5868C75.6872 29.494 75.7052 29.402 75.7405 29.3162C75.7759 29.2304 75.8279 29.1525 75.8935 29.0868C75.9591 29.0212 76.0371 28.9692 76.1229 28.9339C76.2087 28.8985 76.3006 28.8805 76.3934 28.8809H113.869C114.056 28.8809 114.236 28.9552 114.368 29.0876C114.501 29.22 114.575 29.3996 114.575 29.5868C114.575 29.774 114.501 29.9536 114.368 30.086C114.236 30.2183 114.056 30.2927 113.869 30.2927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    opacity: 0.1,
    d: "M113.869 33.439H76.3934C76.2062 33.439 76.0267 33.3646 75.8943 33.2322C75.7619 33.0998 75.6875 32.9202 75.6875 32.733C75.6872 32.6401 75.7052 32.548 75.7405 32.4621C75.7758 32.3761 75.8277 32.298 75.8933 32.2321C75.9589 32.1663 76.0368 32.1141 76.1227 32.0784C76.2085 32.0428 76.3005 32.0244 76.3934 32.0244H113.869C114.057 32.0251 114.236 32.1001 114.369 32.2329C114.501 32.3657 114.575 32.5456 114.575 32.733C114.575 32.9202 114.501 33.0998 114.368 33.2322C114.236 33.3646 114.056 33.439 113.869 33.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    opacity: 0.1,
    d: "M113.872 35.1699H76.3934C76.0036 35.1699 75.6875 35.486 75.6875 35.8758V35.8785C75.6875 36.2684 76.0036 36.5845 76.3934 36.5845H113.872C114.262 36.5845 114.578 36.2684 114.578 35.8785V35.8758C114.578 35.486 114.262 35.1699 113.872 35.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    opacity: 0.1,
    d: "M113.869 39.7243H76.3934C76.2062 39.7243 76.0267 39.65 75.8943 39.5176C75.7619 39.3852 75.6875 39.2056 75.6875 39.0184C75.6875 38.8312 75.7619 38.6516 75.8943 38.5193C76.0267 38.3869 76.2062 38.3125 76.3934 38.3125H113.869C114.056 38.3125 114.236 38.3869 114.368 38.5193C114.501 38.6516 114.575 38.8312 114.575 39.0184C114.575 39.2056 114.501 39.3852 114.368 39.5176C114.236 39.65 114.056 39.7243 113.869 39.7243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    opacity: 0.1,
    d: "M113.869 42.8738H76.3934C76.2062 42.8738 76.0267 42.7994 75.8943 42.667C75.7619 42.5346 75.6875 42.3551 75.6875 42.1678C75.6872 42.075 75.7052 41.9831 75.7405 41.8973C75.7759 41.8115 75.8279 41.7335 75.8935 41.6679C75.9591 41.6023 76.0371 41.5503 76.1229 41.5149C76.2087 41.4796 76.3006 41.4616 76.3934 41.4619H113.869C114.056 41.4619 114.236 41.5363 114.368 41.6687C114.501 41.8011 114.575 41.9806 114.575 42.1678C114.575 42.3551 114.501 42.5346 114.368 42.667C114.236 42.7994 114.056 42.8738 113.869 42.8738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    opacity: 0.1,
    d: "M113.869 46.019H76.3934C76.2062 46.019 76.0267 45.9447 75.8943 45.8123C75.7619 45.6799 75.6875 45.5003 75.6875 45.3131C75.6872 45.2202 75.7052 45.1281 75.7405 45.0421C75.7758 44.9562 75.8277 44.878 75.8933 44.8122C75.9589 44.7464 76.0368 44.6941 76.1227 44.6585C76.2085 44.6228 76.3005 44.6045 76.3934 44.6045H113.869C114.057 44.6052 114.236 44.6802 114.369 44.813C114.501 44.9458 114.575 45.1256 114.575 45.3131C114.575 45.5003 114.501 45.6799 114.368 45.8123C114.236 45.9447 114.056 46.019 113.869 46.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    opacity: 0.1,
    d: "M113.869 49.1655H76.3934C76.3005 49.1655 76.2085 49.1472 76.1227 49.1115C76.0368 49.0759 75.9589 49.0236 75.8933 48.9578C75.8277 48.892 75.7758 48.8138 75.7405 48.7279C75.7052 48.6419 75.6872 48.5498 75.6875 48.4569C75.6875 48.2697 75.7619 48.0901 75.8943 47.9577C76.0267 47.8254 76.2062 47.751 76.3934 47.751H113.869C114.056 47.751 114.236 47.8254 114.368 47.9577C114.501 48.0901 114.575 48.2697 114.575 48.4569C114.575 48.6444 114.501 48.8242 114.369 48.957C114.236 49.0898 114.057 49.1648 113.869 49.1655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    opacity: 0.1,
    d: "M92.3962 52.3083H76.3934C76.2062 52.3083 76.0267 52.234 75.8943 52.1016C75.7619 51.9692 75.6875 51.7896 75.6875 51.6024C75.6875 51.4152 75.7619 51.2356 75.8943 51.1032C76.0267 50.9709 76.2062 50.8965 76.3934 50.8965H92.3962C92.5834 50.8965 92.763 50.9709 92.8954 51.1032C93.0278 51.2356 93.1021 51.4152 93.1021 51.6024C93.1021 51.7896 93.0278 51.9692 92.8954 52.1016C92.763 52.234 92.5834 52.3083 92.3962 52.3083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M110.988 21.092L110.937 21.049C110.792 20.939 110.709 20.9765 110.642 20.7645C110.594 20.6115 110.642 20.4397 110.586 20.2814C110.458 20.0087 110.312 19.7451 110.148 19.4922L109.488 18.3031C109.34 18.0398 109.095 17.8457 108.804 17.7632C108.514 17.6807 108.203 17.7166 107.939 17.863L101.86 21.2503C101.835 21.4543 101.666 21.5939 101.631 21.7871C101.619 21.8443 101.622 21.9035 101.64 21.959C101.658 22.0146 101.69 22.0645 101.733 22.1039C101.665 22.1025 101.599 22.079 101.546 22.0368C101.183 21.8355 101.087 21.6744 100.713 21.8784C100.552 21.9643 100.394 22.0556 100.236 22.1468L98.6252 23.046L93.579 25.8563L87.6739 29.1524L82.7539 31.8929C82.0829 32.266 81.2696 32.5934 80.671 33.0685C80.8374 33.1544 80.867 33.2859 80.7193 33.4148L80.4509 33.659C80.4509 33.7261 80.5475 33.7261 80.6093 33.6993L80.9421 33.557C80.7109 33.8507 80.4324 34.1037 80.1181 34.3059C79.5903 34.6123 79.0232 34.8453 78.4324 34.9984L78.717 34.6414C78.7384 34.6119 78.7653 34.5743 78.7465 34.5394C78.7277 34.5045 78.6928 34.5019 78.6606 34.4992C78.5183 34.4831 78.3761 34.4992 78.2714 34.3945C77.3534 34.9313 76.3925 35.4413 75.4584 35.962C75.1951 36.1095 75.001 36.3552 74.9185 36.6455C74.836 36.9357 74.8718 37.2469 75.0182 37.5108L81.1488 48.5157C81.2213 48.6462 81.3188 48.7612 81.4358 48.854C81.5528 48.9468 81.6869 49.0156 81.8305 49.0565C81.9741 49.0974 82.1244 49.1095 82.2727 49.0923C82.421 49.075 82.5645 49.0287 82.6948 48.9559L84.308 48.046C84.308 47.8554 84.4583 47.6433 84.3456 47.4689C84.3296 47.4477 84.3195 47.4227 84.3161 47.3964C84.3161 47.3615 84.3483 47.3347 84.3778 47.3159C84.5431 47.2109 84.7325 47.1499 84.928 47.1387C84.9951 47.1387 85.0837 47.1683 85.073 47.2327C85.073 47.1736 85.4192 47.0502 85.4756 47.0314C85.5024 47.1763 85.4031 47.332 85.5722 47.3615C85.7413 47.391 85.999 47.0931 86.1091 47.0394L87.7195 46.1402L92.8194 43.3031L98.4131 40.1868L102.131 38.1147C102.265 38.0369 102.423 37.9456 102.552 37.8812C102.599 37.635 102.718 37.4087 102.896 37.2316C103.164 37.0464 103.588 37.2504 103.811 36.9874C103.854 36.9364 103.881 36.8746 103.918 36.8209C103.993 36.7336 104.084 36.6616 104.187 36.6089C104.252 36.5579 104.33 36.5271 104.412 36.5203C104.493 36.5203 104.579 36.5874 104.568 36.6679C105.121 36.5391 105.62 36.166 106.109 35.8896C106.286 35.7902 107.84 35.0602 107.834 34.9447C107.813 34.5877 108.03 34.2818 108.02 33.914C108.02 33.8442 107.883 33.3772 107.944 33.3423C106.549 34.1744 105.099 34.9313 103.677 35.7205C103.628 35.75 103.446 35.8117 103.408 35.8654C103.408 35.8654 103.395 35.8895 103.39 35.903L103.349 35.9915V36.013C103.291 36.1957 103.223 36.3749 103.145 36.5498C103.145 36.574 102.842 36.9498 102.818 36.8612C102.7 36.4291 102.549 36.362 102.219 36.5391L101.747 36.8075L100.246 37.6423L95.1922 40.4606L89.2361 43.7782L84.2731 46.5428L82.1929 47.6997C81.7778 46.9482 81.3599 46.1975 80.9394 45.4477L80.1342 44.001C80.0527 43.8004 79.9323 43.618 79.7799 43.4642C79.6645 43.3783 79.4685 43.3997 79.3665 43.3219C79.1169 43.1313 78.9371 42.7851 78.7009 42.5623C78.5398 42.412 78.2956 41.961 78.3627 41.7114C78.4432 41.7436 78.5237 41.7785 78.6042 41.8027C78.5621 41.6374 78.5715 41.4632 78.6311 41.3034C77.8258 39.948 77.085 38.5307 76.3147 37.1457L76.2637 37.0571L78.1426 36.0103L79.5141 35.2454C79.7962 35.1241 80.0659 34.9758 80.3194 34.8025C80.4939 34.6522 80.671 34.4643 80.8562 34.3032C80.9805 34.2087 81.1157 34.1294 81.2588 34.067L81.7661 33.8201C81.7922 33.8044 81.8217 33.7952 81.852 33.7932C81.8824 33.7966 81.9121 33.8038 81.9406 33.8147C82.209 33.8711 82.8747 33.3745 83.1163 33.2403L84.6784 32.3707L89.3918 29.7429L95.2646 26.4736L101.143 23.1963L105.872 20.5632L108.288 19.2211L108.401 19.1594L111.012 23.8486C111.174 24.1646 111.433 24.4205 111.751 24.5786C111.858 24.6135 111.979 24.6887 111.965 24.7987C111.952 24.9088 111.791 25 111.828 25.1128C111.866 25.2255 112.073 25.1826 112.121 25.2846C112.169 25.3866 112.038 25.553 112.054 25.6926C112.109 25.8596 112.192 26.0165 112.298 26.1569L113.058 27.5231C113.482 28.28 113.903 29.0397 114.33 29.8046L109.686 32.3921C109.709 32.4106 109.729 32.4334 109.743 32.4592L109.767 32.521C109.859 32.5536 109.949 32.5931 110.035 32.6391C110.072 32.6598 110.103 32.6902 110.124 32.7272C110.145 32.7641 110.155 32.8061 110.154 32.8484C110.153 32.8903 110.141 32.9313 110.119 32.9672C110.098 33.003 110.067 33.0324 110.03 33.0524L109.746 33.2135C109.735 33.2757 109.707 33.3334 109.663 33.3789C109.619 33.4245 109.563 33.4557 109.501 33.4685C109.468 33.4712 109.435 33.4712 109.402 33.4685C109.374 33.4892 109.341 33.5035 109.307 33.5104C109.273 33.5174 109.237 33.5168 109.203 33.5087C109.143 33.49 109.091 33.4486 109.06 33.3931C109.029 33.3376 109.021 33.2723 109.037 33.2108C109.048 33.1832 109.062 33.157 109.08 33.133C109.06 33.0938 109.05 33.0499 109.053 33.0059C109.056 32.9619 109.071 32.9195 109.096 32.8833H109.01C108.962 32.8833 108.919 32.8565 108.873 32.8431C108.632 32.9922 108.444 33.2139 108.336 33.4765C108.325 33.4908 108.319 33.5091 108.32 33.5275C108.32 33.5651 108.379 33.5678 108.414 33.5839C108.495 33.6215 108.476 33.7396 108.436 33.8174C108.395 33.8952 108.347 33.9946 108.401 34.0643C108.421 34.0878 108.444 34.1094 108.468 34.1288C108.583 34.2603 108.406 34.6414 108.688 34.4858C108.668 34.4029 108.681 34.3155 108.723 34.2415C108.771 34.1668 108.844 34.1123 108.93 34.0885C109.138 34.0379 109.351 34.0073 109.566 33.9972L115.162 30.8675C115.425 30.7201 115.62 30.4744 115.702 30.1841C115.785 29.8938 115.749 29.5827 115.602 29.3188L115.57 29.2624L113.042 24.7236L111.581 22.0985C111.439 21.8489 111.313 21.5885 111.157 21.3416C111.115 21.2499 111.057 21.1657 110.988 21.092Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M85.1226 35.9212C84.9374 35.6957 84.9938 35.6904 84.9589 35.4488C84.9589 35.4488 84.9589 35.4488 84.9589 35.4327L84.9374 35.4085L84.9052 35.3709C84.7791 35.4273 84.6529 35.489 84.5268 35.5588L82.0547 36.9358L83.0505 38.7207C82.9109 38.4738 83.4048 38.5463 83.4236 38.5436C83.476 38.5281 83.5301 38.5191 83.5846 38.5167C83.6383 38.5281 83.6854 38.5599 83.7162 38.6053C83.8194 38.7858 83.8501 38.9989 83.8021 39.2012C83.7725 39.4696 83.9148 39.738 83.7618 40.0064C83.8933 40.2212 85.0824 42.3846 85.0878 42.3819L87.5598 41.0049C87.7021 40.9244 88.0403 40.7821 88.1235 40.6399C88.2067 40.4976 88.0752 40.2748 88.2228 40.2077C88.2784 40.1874 88.3379 40.1797 88.3969 40.1852C88.4559 40.1908 88.5129 40.2095 88.5637 40.24C89.0345 39.7738 89.3372 39.1644 89.4242 38.5076C89.5111 37.8508 89.3775 37.1836 89.0442 36.611C88.349 35.3629 86.7707 34.6194 85.3884 35.1992C85.2917 35.2394 85.4206 35.6716 85.1898 35.7199C85.2339 35.6333 85.2972 35.558 85.375 35.4998M86.9156 39.993L85.7642 40.6345C85.6702 40.4654 85.5789 40.2963 85.4823 40.1326C85.6031 40.3366 85.2703 40.2722 85.2005 40.2265C85.0314 40.1138 84.9858 39.789 84.9804 39.6065C84.9763 39.2935 84.8832 38.9881 84.712 38.7261C84.4418 38.2376 84.1734 37.7491 83.9067 37.2606L85.0582 36.6191C86.1319 36.0178 87.2055 36.2674 87.7853 37.3089C88.3651 38.3503 87.9974 39.3998 86.9156 39.993Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M93.3034 31.3498C93.3621 31.4773 93.379 31.6201 93.3517 31.7578C93.3383 31.833 93.2175 32.0262 93.2336 32.0746C93.2765 32.1819 93.3195 32.2893 93.3597 32.3966C93.367 32.4142 93.3769 32.4305 93.3892 32.445C93.4099 32.4588 93.4342 32.4663 93.459 32.4664C93.8858 32.504 93.867 32.547 93.8939 32.9066C93.918 33.2153 94.1838 33.3925 94.3341 33.6609C94.5359 34.0135 94.6236 34.4201 94.5852 34.8246C94.5467 35.2291 94.3839 35.6118 94.1191 35.9201C93.8544 36.2283 93.5007 36.4471 93.1066 36.5462C92.7126 36.6454 92.2975 36.6201 91.9183 36.4738C91.9083 36.4836 91.8975 36.4925 91.8861 36.5007C91.8297 36.5291 91.7651 36.5367 91.7036 36.5222C91.5641 36.4826 91.4378 36.4062 91.3381 36.3008C91.2384 36.1954 91.169 36.0651 91.1373 35.9236C91.1333 35.9023 91.1333 35.8805 91.1373 35.8592C91.0613 35.7652 90.9939 35.6646 90.936 35.5585C90.798 35.3368 90.7074 35.0889 90.6696 34.8305C90.6319 34.572 90.648 34.3086 90.7167 34.0566C90.7855 33.8047 90.9056 33.5696 91.0694 33.3662C91.2332 33.1628 91.4372 32.9954 91.6687 32.8744C92.0043 32.683 92.3891 32.5952 92.7746 32.6221L92.7531 32.5899C92.5223 32.2839 93.3544 32.1604 92.9786 31.9538C92.8202 31.8679 92.8471 31.4787 92.8068 31.3203C92.197 31.3341 91.6003 31.4992 91.0702 31.8008C89.3523 32.759 88.7591 34.6567 89.661 36.2752C90.0404 36.9715 90.6681 37.4995 91.4191 37.7542C91.5957 37.831 91.785 37.8747 91.9774 37.883C92.1975 37.8642 92.0901 37.883 92.1841 37.7515C92.278 37.62 92.2216 37.5636 92.3639 37.424C92.5062 37.2844 92.6726 37.2012 92.7021 36.9865C92.7021 37.0831 92.8095 37.1529 92.8095 37.2549C92.8095 37.2844 92.8095 37.314 92.8095 37.3408C92.8152 37.3759 92.8311 37.4086 92.8551 37.4348C92.9464 37.5582 93.0994 37.7032 93.102 37.8454C93.4948 37.7803 93.8717 37.6419 94.2133 37.4374C95.9231 36.4846 96.5297 34.5896 95.6224 32.9657C95.1527 32.1363 94.2696 31.4035 93.3034 31.3498Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M98.7861 27.6144L100.627 30.9185L96.0805 29.1202L95.0391 29.7026C95.7423 30.9642 96.4885 32.2123 97.1488 33.498C97.1944 33.3584 97.3018 33.3316 97.4306 33.3128C97.6722 33.2806 97.6641 33.4014 97.7957 33.6402C97.8118 33.6698 97.8306 33.6993 97.8601 33.7047C97.8896 33.71 97.9487 33.6617 97.997 33.6671C98.0453 33.6724 98.0641 33.7315 98.0507 33.7771C98.0337 33.8218 98.0111 33.8642 97.9836 33.9033C97.9057 34.0509 98.0346 34.1449 98.0185 34.2791C98.0185 34.3489 97.7849 34.6334 97.8118 34.6817L98.0802 35.1434L99.3256 34.4508L98.9928 33.855H98.9311C98.5687 33.9033 98.7297 33.4282 98.6492 33.2323C98.5189 32.9547 98.3709 32.6857 98.2063 32.427L97.4736 31.136L101.17 32.5907C101.16 32.4846 101.173 32.3776 101.207 32.2767C101.237 32.2203 101.476 32.1157 101.476 32.062C101.489 32.2351 101.57 32.3959 101.701 32.5102C101.843 32.6364 101.843 32.6176 101.816 32.8404L102.037 32.9289L103.073 32.3519L100.04 26.9111L98.7861 27.6144Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M105.045 29.936L104.342 28.6772L106.87 27.268L106.333 26.2883L103.808 27.6975L103.15 26.5138L104.857 25.5636C104.929 25.4706 105.021 25.3946 105.125 25.3408C105.178 25.3136 105.24 25.3069 105.297 25.322L106.019 24.9221C106.019 24.9221 105.507 24.0068 105.458 23.9102C105.211 24.0229 105.458 24.3342 105.209 24.4846C105.26 24.5382 105.335 24.7288 105.209 24.753C105.136 24.753 105.083 24.6617 105.01 24.6698C104.938 24.6778 104.935 24.7127 104.897 24.702C104.886 24.6988 104.875 24.693 104.867 24.6851C104.858 24.6772 104.851 24.6673 104.846 24.6563C104.812 24.5754 104.767 24.4988 104.715 24.4282C104.546 24.2645 103.002 25.2925 102.788 25.4133L101.352 26.2185L104.382 31.6592L105.592 30.9855L105.617 30.9533C105.705 30.8406 105.791 30.7252 105.885 30.6205C105.923 30.5842 105.972 30.5612 106.024 30.5549C106.076 30.5487 106.129 30.5594 106.175 30.5856C106.197 30.5969 106.216 30.6124 106.231 30.6312L108.596 29.3133L108.032 28.3014L105.045 29.936Z",
    fill: "#339999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M108.273 87.8268C108.273 87.8268 106.507 83.9778 108.523 80.1798C110.539 76.3817 111.126 75.4879 109.841 74.7122C108.555 73.9365 107.962 77.7479 107.962 77.7479C107.962 77.7479 106.888 75.1229 107.771 72.3797C108.654 69.6365 109.229 65.1594 108.007 64.6789C106.786 64.1985 107.774 70.2592 106.714 72.326C106.173 70.8753 105.824 69.3603 105.675 67.8194C105.53 65.613 105.758 62.0914 104.792 61.1869C103.826 60.2823 103.211 60.9185 104.158 65.7767C104.728 68.6865 105.043 71.6404 105.1 74.6048C105.1 74.6048 103.004 68.2166 101.611 68.0314C100.218 67.8462 100.207 69.9103 101.412 71.706C102.618 73.5017 104.926 76.7119 105.304 78.376C105.304 78.376 103.007 73.5714 100.937 75.0423C98.8679 76.5132 102.738 79.4202 104.462 80.4697C106.185 81.5191 107.385 88.0926 107.385 88.0926L108.273 87.8268Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    opacity: 0.2,
    d: "M108.273 87.8268C108.273 87.8268 106.507 83.9778 108.523 80.1798C110.539 76.3817 111.126 75.4879 109.841 74.7122C108.555 73.9365 107.962 77.7479 107.962 77.7479C107.962 77.7479 106.888 75.1229 107.771 72.3797C108.654 69.6365 109.229 65.1594 108.007 64.6789C106.786 64.1985 107.774 70.2592 106.714 72.326C106.173 70.8753 105.824 69.3603 105.675 67.8194C105.53 65.613 105.758 62.0914 104.792 61.1869C103.826 60.2823 103.211 60.9185 104.158 65.7767C104.728 68.6865 105.043 71.6404 105.1 74.6048C105.1 74.6048 103.004 68.2166 101.611 68.0314C100.218 67.8462 100.207 69.9103 101.412 71.706C102.618 73.5017 104.926 76.7119 105.304 78.376C105.304 78.376 103.007 73.5714 100.937 75.0423C98.8679 76.5132 102.738 79.4202 104.462 80.4697C106.185 81.5191 107.385 88.0926 107.385 88.0926L108.273 87.8268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M106.877 89.4077C106.877 89.4077 108.598 85.5291 106.537 81.7633C104.475 77.9975 103.877 77.1117 105.154 76.3145C106.432 75.5173 107.065 79.3234 107.065 79.3234C107.065 79.3234 108.117 76.6849 107.191 73.9552C106.265 71.2254 105.648 66.7563 106.864 66.2598C108.08 65.7632 107.165 71.8374 108.249 73.8854C108.773 72.4281 109.103 70.9085 109.231 69.3653C109.352 67.1563 109.081 63.6374 110.037 62.7194C110.992 61.8015 111.618 62.4188 110.726 67.3012C110.192 70.2177 109.913 73.1751 109.892 76.1401C109.892 76.1401 111.91 69.7223 113.314 69.5156C114.718 69.3089 114.739 71.3757 113.558 73.1875C112.377 74.9993 110.096 78.2471 109.733 79.8978C109.733 79.8978 111.975 75.0664 114.06 76.5024C116.146 77.9384 112.313 80.9044 110.603 81.978C108.893 83.0517 107.763 89.6493 107.763 89.6493L106.877 89.4077Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M114.808 86.6436H100.609L101.758 96.8057H113.66L114.808 86.6436Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speech-bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M42.1765 22.748H32.8062C32.4452 22.748 32.0991 22.8914 31.8439 23.1466C31.5887 23.4018 31.4453 23.748 31.4453 24.1089V33.2188C31.4453 33.5797 31.5887 33.9259 31.8439 34.1811C32.0991 34.4363 32.4452 34.5797 32.8062 34.5797H35.8043L33.7859 37.3229L37.2752 34.5797H42.1738C42.5347 34.5797 42.8808 34.4363 43.1361 34.1811C43.3913 33.9259 43.5346 33.5797 43.5346 33.2188V24.1089C43.5346 23.7484 43.3916 23.4027 43.137 23.1476C42.8824 22.8924 42.5369 22.7488 42.1765 22.748Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    opacity: 0.6,
    d: "M42.1765 22.748H32.8062C32.4452 22.748 32.0991 22.8914 31.8439 23.1466C31.5887 23.4018 31.4453 23.748 31.4453 24.1089V33.2188C31.4453 33.5797 31.5887 33.9259 31.8439 34.1811C32.0991 34.4363 32.4452 34.5797 32.8062 34.5797H35.8043L33.7859 37.3229L37.2752 34.5797H42.1738C42.5347 34.5797 42.8808 34.4363 43.1361 34.1811C43.3913 33.9259 43.5346 33.5797 43.5346 33.2188V24.1089C43.5346 23.7484 43.3916 23.4027 43.137 23.1476C42.8824 22.8924 42.5369 22.7488 42.1765 22.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M37.4965 32.9188C39.8461 32.9188 41.7509 31.0141 41.7509 28.6645C41.7509 26.3149 39.8461 24.4102 37.4965 24.4102C35.1469 24.4102 33.2422 26.3149 33.2422 28.6645C33.2422 31.0141 35.1469 32.9188 37.4965 32.9188Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    opacity: 0.2,
    d: "M41.0399 29.4987C41.5026 27.538 40.2883 25.5734 38.3276 25.1106C36.3669 24.6478 34.4023 25.8621 33.9395 27.8229C33.4767 29.7836 34.691 31.7482 36.6518 32.211C38.6125 32.6737 40.5771 31.4594 41.0399 29.4987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M37.0401 30.4059C36.9907 30.407 36.9415 30.3983 36.8955 30.3803C36.8494 30.3623 36.8074 30.3355 36.7717 30.3012L35.223 28.7847C35.1518 28.7156 35.1109 28.6211 35.1094 28.522C35.1079 28.4228 35.1459 28.3271 35.2149 28.2559C35.284 28.1847 35.3785 28.1439 35.4776 28.1424C35.5768 28.1409 35.6725 28.1788 35.7437 28.2479L37.0133 29.4906L39.2089 27.04C39.2762 26.9721 39.367 26.9327 39.4626 26.9299C39.5581 26.927 39.6511 26.9609 39.7224 27.0246C39.7936 27.0883 39.8377 27.1769 39.8456 27.2722C39.8534 27.3674 39.8244 27.4621 39.7645 27.5366L37.3085 30.2771C37.2747 30.315 37.2333 30.3455 37.1872 30.3667C37.141 30.388 37.0909 30.3995 37.0401 30.4005V30.4059Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M25.3347 90.7018L33.0677 89.9395V81.2188H36.133V89.9368L43.8982 90.7018C44.2703 90.7378 44.6156 90.9112 44.8667 91.1882C45.1178 91.4651 45.2568 91.8257 45.2564 92.1995V93.3617H23.9766V92.1995C23.9762 91.8257 24.1151 91.4651 24.3662 91.1882C24.6173 90.9112 24.9626 90.7378 25.3347 90.7018Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    opacity: 0.1,
    d: "M25.3347 90.7018L33.0677 89.9395V81.2188H36.133V89.9368L43.8982 90.7018C44.2703 90.7378 44.6156 90.9112 44.8667 91.1882C45.1178 91.4651 45.2568 91.8257 45.2564 92.1995V93.3617H23.9766V92.1995C23.9762 91.8257 24.1151 91.4651 24.3662 91.1882C24.6173 90.9112 24.9626 90.7378 25.3347 90.7018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M44.4347 96.805C45.5421 96.805 46.4398 95.9073 46.4398 94.8C46.4398 93.6926 45.5421 92.7949 44.4347 92.7949C43.3274 92.7949 42.4297 93.6926 42.4297 94.8C42.4297 95.9073 43.3274 96.805 44.4347 96.805Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M24.7941 96.805C25.9015 96.805 26.7992 95.9073 26.7992 94.8C26.7992 93.6926 25.9015 92.7949 24.7941 92.7949C23.6868 92.7949 22.7891 93.6926 22.7891 94.8C22.7891 95.9073 23.6868 96.805 24.7941 96.805Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M35.5477 83.5537H33.6366C33.3426 83.5537 33.0606 83.4369 32.8527 83.229C32.6448 83.0211 32.5281 82.7392 32.5281 82.4452V73.8721H36.6562V82.4452C36.6563 82.7392 36.5395 83.0211 36.3316 83.229C36.1237 83.4369 35.8417 83.5537 35.5477 83.5537Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    opacity: 0.2,
    d: "M35.5477 83.5537H33.6366C33.3426 83.5537 33.0606 83.4369 32.8527 83.229C32.6448 83.0211 32.5281 82.7392 32.5281 82.4452V73.8721H36.6562V82.4452C36.6563 82.7392 36.5395 83.0211 36.3316 83.229C36.1237 83.4369 35.8417 83.5537 35.5477 83.5537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M23.8945 57.0703C23.8945 57.0703 26.1921 71.3982 30.7283 73.8756H26.117C26.117 73.8756 21.554 68.9905 20.1797 57.0703H23.8945Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    opacity: 0.1,
    d: "M23.8945 57.0703C23.8945 57.0703 26.1921 71.3982 30.7283 73.8756H26.117C26.117 73.8756 21.554 68.9905 20.1797 57.0703H23.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M25.8968 71.8486H43.859C44.2149 71.8486 44.5563 71.99 44.8079 72.2417C45.0596 72.4934 45.201 72.8348 45.201 73.1907V74.9864H24.5547V73.1907C24.5547 72.8348 24.6961 72.4934 24.9478 72.2417C25.1995 71.99 25.5408 71.8486 25.8968 71.8486Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M45.5149 73.416H24.227C23.929 73.416 23.6875 73.6576 23.6875 73.9555V74.444C23.6875 74.742 23.929 74.9835 24.227 74.9835H45.5149C45.8128 74.9835 46.0544 74.742 46.0544 74.444V73.9555C46.0544 73.6576 45.8128 73.416 45.5149 73.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    opacity: 0.6,
    d: "M45.5149 73.416H24.227C23.929 73.416 23.6875 73.6576 23.6875 73.9555V74.444C23.6875 74.742 23.929 74.9835 24.227 74.9835H45.5149C45.8128 74.9835 46.0544 74.742 46.0544 74.444V73.9555C46.0544 73.6576 45.8128 73.416 45.5149 73.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M19.6326 59.9844H27.0113C29.1747 59.9844 30.5785 58.2504 30.149 56.1112L29.5746 53.2553C29.1452 51.108 27.0435 49.3848 24.8828 49.3848H17.5041C15.3407 49.3848 13.9369 51.1187 14.3663 53.2553L14.9407 56.1112C15.3702 58.2451 17.4692 59.9844 19.6326 59.9844Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M58.7862 83.9833L57.0952 84.6463L55.8793 82.354L54.7734 80.2684L56.647 79.1465L57.7797 81.7045L58.7862 83.9833Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    opacity: 0.2,
    d: "M57.7797 81.7045L55.8793 82.354L54.7734 80.2684L56.647 79.1465L57.7797 81.7045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M57.4255 80.4536L55.1252 81.6883C55.1252 81.6883 46.4313 66.4022 45.0946 66.5311C43.7579 66.6599 31.0754 74.7391 27.2075 71.7544C23.3397 68.7696 27.1029 59.7832 27.1029 59.7832C27.1029 59.7832 35.1043 57.4963 35.9605 59.2464C36.1862 59.7704 36.378 60.3083 36.5349 60.8568C36.704 61.4071 36.8328 61.8714 36.8328 61.8714C37.0771 61.7721 44.9792 58.5324 48.5061 60.261C52.1055 62.0379 57.4255 80.4536 57.4255 80.4536Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    opacity: 0.3,
    d: "M57.4255 80.4536L55.1252 81.6883C55.1252 81.6883 46.4313 66.4022 45.0946 66.5311C43.7579 66.6599 31.0754 74.7391 27.2075 71.7544C23.3397 68.7696 27.1029 59.7832 27.1029 59.7832C27.1029 59.7832 35.1043 57.4963 35.9605 59.2464C36.1862 59.7704 36.378 60.3083 36.5349 60.8568C36.704 61.4071 36.8328 61.8714 36.8328 61.8714C37.0771 61.7721 44.9792 58.5324 48.5061 60.261C52.1055 62.0379 57.4255 80.4536 57.4255 80.4536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M44.9265 92.9189L43.1228 92.7122L43.1121 90.1677L43.1094 87.8325L45.2916 87.7305L45.0983 90.4763L44.9265 92.9189Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    opacity: 0.2,
    d: "M45.0956 90.5327L43.1094 90.216V87.8566L45.2916 87.7412L45.0956 90.5327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M54 80.9288L57.3659 79.2432L57.7175 80.6711L55.1676 81.9863L54 80.9288Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M33.1875 71.7791C33.1875 71.7791 33.7404 71.7174 42.2464 70.1418C42.2464 70.1418 42.4397 81.0179 42.8423 89.1266L45.462 89.2098C45.462 89.2098 49.2198 71.2262 48.7769 68.4991C48.3341 65.772 45.1024 65.415 45.1024 65.415C45.1024 65.415 39.4898 69.7875 33.1875 71.7791Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    opacity: 0.4,
    d: "M33.1875 71.7791C33.1875 71.7791 33.7404 71.7174 42.2464 70.1418C42.2464 70.1418 42.4397 81.0179 42.8423 89.1266L45.462 89.2098C45.462 89.2098 49.2198 71.2262 48.7769 68.4991C48.3341 65.772 45.1024 65.415 45.1024 65.415C45.1024 65.415 39.4898 69.7875 33.1875 71.7791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    opacity: 0.3,
    d: "M33.1875 71.7791C33.1875 71.7791 33.7404 71.7174 42.2464 70.1418C42.2464 70.1418 42.4397 81.0179 42.8423 89.1266L45.462 89.2098C45.462 89.2098 49.2198 71.2262 48.7769 68.4991C48.3341 65.772 45.1024 65.415 45.1024 65.415C45.1024 65.415 39.4898 69.7875 33.1875 71.7791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M42.3594 88.4016L45.932 88.3184L45.4434 89.7893L42.5446 89.8161L42.3594 88.4016Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    opacity: 0.3,
    d: "M36.8464 61.8769L32.2109 63.5276C32.2109 63.5276 34.6481 61.7078 36.5485 60.8623C36.7176 61.4126 36.8464 61.8769 36.8464 61.8769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M26.5703 59.2308L26.7421 60.5165L35.4306 58.6725L35.2293 57.1533L26.5703 59.2308Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    opacity: 0.2,
    d: "M26.5703 59.2308L26.7421 60.5165L35.4306 58.6725L35.2293 57.1533L26.5703 59.2308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M29.4484 58.2957L29.0156 58.376L29.4244 60.5796L29.8573 60.4993L29.4484 58.2957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M33.2317 57.7388L31.3359 58.166L31.6599 59.6036L33.5557 59.1763L33.2317 57.7388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M34.4548 56.8407L34.0234 56.9199L34.4269 59.1163L34.8583 59.0371L34.4548 56.8407Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    opacity: 0.3,
    d: "M29.4484 58.2957L29.0156 58.376L29.4244 60.5796L29.8573 60.4993L29.4484 58.2957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    opacity: 0.3,
    d: "M34.4548 56.8407L34.0234 56.9199L34.4269 59.1163L34.8583 59.0371L34.4548 56.8407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M62.1452 86.9839C61.863 86.8973 61.5673 86.8636 61.2728 86.8846C61.2728 86.8846 60.1804 86.4283 58.8571 84.2568L57.7298 84.4045C57.5401 84.433 57.3637 84.5191 57.2245 84.6511C57.0853 84.7831 56.9899 84.9547 56.9514 85.1426C56.9433 85.196 56.9433 85.2503 56.9514 85.3036C56.9999 85.5761 57.0663 85.8451 57.15 86.1089C57.4391 86.9814 57.7806 87.8356 58.1727 88.6669L58.3552 88.5917L57.7727 86.9651C57.5795 86.4095 58.2532 86.8792 58.6102 87.4161C58.9672 87.9529 59.4745 88.4736 60.6796 88.0173C62.0808 87.4697 62.6364 87.1799 62.1452 86.9839Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M58.5725 83.6807C58.5725 83.6807 60.3816 86.4292 61.2701 86.8855C61.2701 86.8855 60.2742 87.6907 58.9456 86.397C57.2304 84.7355 56.9432 85.3046 56.9432 85.3046C56.9279 84.9791 56.9432 84.6529 56.9889 84.3302C57.1258 83.6994 58.5725 83.6807 58.5725 83.6807Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M47.6347 96.1187C47.3776 95.9705 47.0956 95.8705 46.8026 95.8235C46.8026 95.8235 45.8497 95.1229 45.0848 92.7018L43.9547 92.5784C43.763 92.5602 43.5703 92.6021 43.4035 92.6983C43.2366 92.7945 43.1038 92.9402 43.0233 93.1152C42.9993 93.1633 42.983 93.2149 42.975 93.2682C42.9562 93.5425 42.9562 93.8178 42.975 94.0922C43.0478 95.0083 43.1769 95.919 43.3615 96.8193L43.5575 96.7897L43.383 95.0665C43.3266 94.4814 43.8715 95.0987 44.0916 95.7054C44.3117 96.312 44.6795 96.9374 45.9571 96.779C47.4495 96.5777 48.0561 96.4274 47.6347 96.1187Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M44.9494 92.0652C44.9494 92.0652 46.0553 95.1653 46.8095 95.8229C46.8095 95.8229 45.6526 96.3598 44.6622 94.7976C43.3872 92.7765 42.9766 93.2623 42.9766 93.2623C43.0366 92.9432 43.1265 92.6305 43.245 92.3282C43.5295 91.7377 44.9494 92.0652 44.9494 92.0652Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M24.6782 37.3086L22.4074 37.7649C22.3187 37.8396 22.2139 37.8928 22.1012 37.9203C21.9885 37.9478 21.871 37.9488 21.7579 37.9233C21.0814 37.6548 20.1071 36.8684 19.9836 36.5812C19.8011 36.1759 19.9836 34.9868 20.4614 34.7721C20.9392 34.5574 22.5846 36.5436 22.5846 36.5436L25.0244 35.9934L24.6782 37.3086Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M31.8354 44.8567C31.8354 44.8567 31.6287 37.4995 30.7778 37.1854C29.927 36.8714 23.5307 37.7491 23.5307 37.7491L23.375 36.0688C23.375 36.0688 30.8181 34.9227 32.2595 35.6018C33.7009 36.2809 34.1759 47.2455 33.9129 49.3579L31.8354 44.8567Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    opacity: 0.6,
    d: "M31.8354 44.8567C31.8354 44.8567 31.6287 37.4995 30.7778 37.1854C29.927 36.8714 23.5307 37.7491 23.5307 37.7491L23.375 36.0688C23.375 36.0688 30.8181 34.9227 32.2595 35.6018C33.7009 36.2809 34.1759 47.2455 33.9129 49.3579L31.8354 44.8567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M23.6409 37.9105L23.1953 36.0638L23.8341 35.833L24.2394 37.9669L23.6409 37.9105Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    opacity: 0.7,
    d: "M23.6409 37.9105L23.1953 36.0638L23.8341 35.833L24.2394 37.9669L23.6409 37.9105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M31.7979 43.9385C31.7979 43.9385 31.2262 46.177 28.4723 46.891C25.7184 47.605 22.6719 45.7395 22.6719 45.7395L23.2785 51.0809L26.6498 59.4957L35.2658 57.2491C35.2658 57.2491 34.7505 47.4601 31.7979 43.9385Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    opacity: 0.7,
    d: "M31.7979 43.9385C31.7979 43.9385 31.2262 46.177 28.4723 46.891C25.7184 47.605 22.6719 45.7395 22.6719 45.7395L23.2785 51.0809L26.6498 59.4957L35.2658 57.2491C35.2658 57.2491 34.7505 47.4601 31.7979 43.9385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    opacity: 0.6,
    d: "M33.297 52.8156L34.3056 52.4974C34.4173 52.4622 34.4792 52.3431 34.444 52.2314L33.8432 50.3269C33.8079 50.2152 33.6888 50.1533 33.5772 50.1885L32.5686 50.5067C32.4569 50.5419 32.3949 50.661 32.4302 50.7727L33.031 52.6772C33.0663 52.7888 33.1854 52.8508 33.297 52.8156Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    opacity: 0.2,
    d: "M33.0954 52.2348L34.2422 51.873L33.7471 50.3039L32.6004 50.6657L33.0954 52.2348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M33.0503 49.7365L32.7969 49.8164L33.0884 50.7405L33.3418 50.6605L33.0503 49.7365Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M25.9405 35.5781C23.8173 35.5781 22.4162 37.8274 22.9128 41.3946C23.4093 44.9618 25.3983 45.9899 25.3983 45.9899L25.2721 45.1283C27.4801 45.6293 29.7566 45.7564 32.0066 45.504C32.0066 45.504 30.9813 42.5944 31.3141 39.6231C31.3141 39.6231 31.9878 35.5728 25.9405 35.5781Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    opacity: 0.2,
    d: "M30.1576 46.1665L31.0246 49.3875L29.5 48.2252C29.5 48.2252 30.9843 51.618 31.3789 53.5935C31.3789 53.5935 30.0958 50.2303 28.99 48.3863L28.3431 50.233L25.7422 47.5837C25.7422 47.5837 28.0398 45.823 30.1576 46.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M28.8909 47.2061L26.2444 47.2866C27.4173 45.7862 25.2969 43.1719 25.2969 43.1719L27.9112 43.7382C28.5339 46.3257 29.6103 46.4036 29.6103 46.4036L28.8909 47.2061Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    opacity: 0.2,
    d: "M28.6413 45.5947C27.6314 45.5102 26.6922 45.0425 26.0162 44.2875C25.8074 43.8997 25.5668 43.5298 25.2969 43.1816L27.9112 43.7507C28.0497 44.4019 28.2965 45.0252 28.6413 45.5947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M27.9118 36.6704C30.1907 36.861 30.8241 38.1413 30.7946 40.5061C30.7597 43.4586 29.933 45.4905 27.1361 44.6262C23.3354 43.4532 24.1245 36.3537 27.9118 36.6704Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M29.3266 40.2617C29.4809 40.6176 29.6774 40.9538 29.9118 41.2629C29.8367 41.3509 29.739 41.4167 29.6293 41.4531C29.5195 41.4896 29.4018 41.4953 29.2891 41.4696L29.3266 40.2617Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M27.7891 39.8808L28.2829 39.7197C28.2829 39.7197 28.0199 40.1116 27.7891 39.8808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M27.9587 39.8245C27.8669 39.7793 27.7618 39.7691 27.663 39.7958C27.5642 39.8225 27.4785 39.8842 27.4219 39.9694C27.5061 39.931 27.5977 39.9111 27.6903 39.9111C27.7829 39.9111 27.8744 39.931 27.9587 39.9694V39.8245Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M27.042 38.7376C27.0166 38.737 26.9925 38.7264 26.9749 38.7081C26.9656 38.6993 26.9581 38.6887 26.953 38.6769C26.9479 38.6652 26.9453 38.6525 26.9453 38.6397C26.9453 38.6268 26.9479 38.6141 26.953 38.6024C26.9581 38.5906 26.9656 38.58 26.9749 38.5712C27.1246 38.4403 27.3026 38.346 27.495 38.2956C27.6874 38.2453 27.8889 38.2404 28.0835 38.2813C28.1087 38.2867 28.1308 38.3018 28.1449 38.3235C28.159 38.3451 28.1639 38.3715 28.1586 38.3967C28.1533 38.422 28.1381 38.4441 28.1165 38.4582C28.0948 38.4723 28.0685 38.4772 28.0432 38.4719C27.8808 38.4387 27.713 38.4425 27.5523 38.4829C27.3915 38.5233 27.2419 38.5994 27.1145 38.7054C27.1055 38.7157 27.0943 38.724 27.0818 38.7295C27.0693 38.7351 27.0557 38.7379 27.042 38.7376Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M30.6121 38.778C30.5909 38.7788 30.57 38.7721 30.5531 38.7592C30.4457 38.6607 30.3177 38.5875 30.1784 38.5448C30.0391 38.502 29.892 38.4909 29.7478 38.5122C29.7355 38.5156 29.7226 38.5165 29.7099 38.5149C29.6973 38.5132 29.685 38.5091 29.6739 38.5028C29.6629 38.4964 29.6531 38.4879 29.6453 38.4778C29.6375 38.4677 29.6317 38.4561 29.6284 38.4438C29.6251 38.4315 29.6242 38.4186 29.6258 38.4059C29.6274 38.3932 29.6315 38.381 29.6379 38.3699C29.6442 38.3588 29.6527 38.3491 29.6628 38.3413C29.6729 38.3335 29.6845 38.3277 29.6968 38.3244C29.8708 38.2936 30.0495 38.303 30.2193 38.3518C30.3891 38.4007 30.5455 38.4877 30.6766 38.6062C30.6964 38.6225 30.7092 38.6459 30.7122 38.6714C30.7152 38.6969 30.7082 38.7226 30.6927 38.7431C30.6829 38.7548 30.6706 38.7641 30.6566 38.7702C30.6426 38.7763 30.6274 38.7789 30.6121 38.778Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M25.0859 40.3046C25.0859 40.3046 26.3072 38.5223 26.2669 37.0621C26.2669 37.0621 30.94 35.5912 30.7816 40.1972C30.7816 40.1972 31.56 36.171 27.6492 35.7442C23.7384 35.3175 23.2848 41.0669 25.1664 42.9457C25.1664 42.9457 24.337 41.4212 25.0859 40.3046Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M25.4275 40.8173C25.4275 40.5516 25.3221 40.2966 25.1344 40.1084C24.9467 39.9203 24.6921 39.8142 24.4263 39.8135C23.7123 39.8323 23.256 41.2549 24.9846 41.7514C25.2315 41.8212 25.3952 41.5877 25.4275 40.8173Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M29.3149 42.1407C29.1478 42.3652 28.9979 42.6021 28.8667 42.8493C28.821 42.8332 28.7727 42.8198 28.7271 42.801C28.0963 42.5782 27.8762 42.2642 27.8252 41.9958C27.8012 41.8594 27.8113 41.7192 27.8547 41.5878C27.8771 41.5122 27.9096 41.4399 27.9514 41.373C28.2793 41.6847 28.6714 41.9211 29.1002 42.0656C29.229 42.1139 29.3149 42.1407 29.3149 42.1407Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M29.097 42.0597L28.9601 42.2664C28.3642 42.0543 27.975 41.8262 27.8516 41.5819C27.8739 41.5063 27.9064 41.4341 27.9482 41.3672C28.2762 41.6789 28.6682 41.9152 29.097 42.0597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M28.7222 42.8004C28.0914 42.5776 27.8713 42.2635 27.8203 41.9951C28.0589 42.083 28.2798 42.213 28.4726 42.3789C28.5975 42.4901 28.6847 42.6374 28.7222 42.8004Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M27.8503 36.8396C27.8503 36.8396 26.6183 40.5142 24.2616 40.2619C21.905 40.0096 25.9446 35.57 25.9446 35.57C25.9446 35.57 29.9198 34.4347 31.651 36.6437C33.3823 38.8527 30.7948 40.1921 30.7948 40.1921C30.7948 40.1921 31.1813 37.3094 27.8503 36.8396Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M25.967 39.9665C25.9533 39.9659 25.9401 39.9615 25.9288 39.954C25.9174 39.9464 25.9084 39.9359 25.9025 39.9236C25.8964 39.9065 25.8972 39.8876 25.9047 39.8711C25.9122 39.8546 25.9259 39.8416 25.9428 39.835C27.8217 39.1183 27.7788 36.5979 27.7788 36.5711C27.778 36.5623 27.7791 36.5535 27.782 36.5451C27.7849 36.5368 27.7896 36.5292 27.7957 36.5229C27.8018 36.5165 27.8092 36.5116 27.8174 36.5083C27.8256 36.505 27.8344 36.5036 27.8432 36.504C27.8606 36.5045 27.8773 36.5113 27.8901 36.5232C27.9029 36.535 27.911 36.5511 27.913 36.5684C27.913 36.5952 27.9559 39.2096 25.9911 39.9611L25.967 39.9665Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M30.1016 40.1037L30.5954 39.9453C30.5954 39.9453 30.3297 40.3345 30.1016 40.1037Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M30.2712 40.0472C30.1792 40.0018 30.0737 39.9917 29.9747 40.0189C29.8757 40.0461 29.7902 40.1087 29.7344 40.1949C29.8174 40.1535 29.9083 40.1307 30.001 40.1279C30.0937 40.1251 30.1859 40.1425 30.2712 40.1787V40.0472Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M26.6228 46.2012L28.6171 47.2158L28.5849 49.2369L25.7344 47.5754L26.6228 46.2012Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M28.9141 45.8203L29.0322 47.047L30.334 48.4239L30.1568 46.1585L28.9141 45.8203Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M19.7006 31.941L18.8686 29.7937C18.8838 29.6789 18.872 29.5621 18.8343 29.4526C18.7965 29.3431 18.7338 29.2439 18.6511 29.1629C18.0714 28.7307 16.8743 28.3389 16.5736 28.3845C16.1361 28.4489 15.2316 29.2407 15.3094 29.7588C15.3872 30.2768 17.9425 30.5962 17.9425 30.5962L18.7907 32.9502L19.7006 31.941Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M23.2849 51.0815C23.2849 51.0815 24.8953 49.8011 24.2538 46.9721L22.5226 39.1451L19.5485 31.0605L18.0938 31.796C18.0938 31.796 20.5363 39.6954 20.7618 40.2295C20.8772 40.4979 21.3362 44.5966 21.9616 47.3425C22.536 49.8709 23.2849 51.0815 23.2849 51.0815Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    opacity: 0.6,
    d: "M23.2849 51.0815C23.2849 51.0815 24.8953 49.8011 24.2538 46.9721L22.5226 39.1451L19.5485 31.0605L18.0938 31.796C18.0938 31.796 20.5363 39.6954 20.7618 40.2295C20.8772 40.4979 21.3362 44.5966 21.9616 47.3425C22.536 49.8709 23.2849 51.0815 23.2849 51.0815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M17.8359 31.5647L19.535 30.7139L19.9054 31.2802L17.9191 32.1606L17.8359 31.5647Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    opacity: 0.7,
    d: "M17.8359 31.5647L19.535 30.7139L19.9054 31.2802L17.9191 32.1606L17.8359 31.5647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    opacity: 0.6,
    d: "M26.6228 46.2012L28.6171 47.2158L28.5849 49.2369L25.7344 47.5754L26.6228 46.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    opacity: 0.6,
    d: "M28.9141 45.8203L29.0322 47.047L30.334 48.4239L30.1568 46.1585L28.9141 45.8203Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M85.5573 41.9824H77.5156V48.2311H85.5573V41.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    opacity: 0.1,
    d: "M85.5614 41.9824H83.5V48.2311H85.5614V41.9824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M77.0547 53.7496H86.1458V42.4092H83.2175L77.0547 45.359V53.7496Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    opacity: 0.2,
    d: "M86.1471 42.4092H83.2188V53.7496H86.1471V42.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    opacity: 0.7,
    d: "M82.2492 47.5947H77.9922V49.6347H82.2492V47.5947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    opacity: 0.7,
    d: "M82.2492 50.3164H77.9922V50.609H82.2492V50.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    opacity: 0.7,
    d: "M85.8647 51.1729H83.5V52.9041H85.8647V51.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M82.1432 41.6416H74.1016V48.2311H82.1432V41.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    opacity: 0.1,
    d: "M82.1395 41.6416H80.0781V48.2311H82.1395V41.6416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M73.6406 53.7496H82.7318V42.4092H79.8034L73.6406 45.359V53.7496Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    opacity: 0.2,
    d: "M82.7331 42.4092H79.8047V53.7496H82.7331V42.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    opacity: 0.7,
    d: "M78.8352 47.5947H74.5781V49.6347H78.8352V47.5947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    opacity: 0.7,
    d: "M78.8352 50.3164H74.5781V50.609H78.8352V50.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    opacity: 0.7,
    d: "M82.4428 51.1729H80.0781V52.9041H82.4428V51.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M67.9922 96.8051H69.6376L72.5901 55.6709H70.4079L67.9922 96.8051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    opacity: 0.1,
    d: "M67.9922 96.8054H69.6376L72.4452 57.7138L72.5901 55.7383H70.4079L70.2925 57.7138L67.9922 96.8054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    opacity: 0.2,
    d: "M70.2969 57.6172H72.4495L72.5945 55.7383H70.4123L70.2969 57.6172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M55.9247 96.8051H57.57L57.8384 55.6709H55.6562L55.9247 96.8051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    opacity: 0.1,
    d: "M55.6562 55.7383L55.7019 62.3734L55.9247 96.8054H57.57L57.7955 62.3734L57.8385 55.7383H55.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    opacity: 0.2,
    d: "M55.6562 55.7383L55.7019 62.4486H57.7955L57.8385 55.7383H55.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M38.4688 96.8051H40.1141L43.0667 55.6709H40.8845L38.4688 96.8051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    opacity: 0.1,
    d: "M38.4688 96.8054H40.1141L42.9244 57.7138L43.0667 55.7383H40.8845L40.7691 57.7138L38.4688 96.8054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    opacity: 0.2,
    d: "M40.7656 57.6172H42.921L43.0632 55.7383H40.881L40.7656 57.6172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M86.8068 96.8051H88.4522L86.0338 55.6709H83.8516L86.8068 96.8051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    opacity: 0.1,
    d: "M83.8516 55.7383L83.9992 57.7138L86.8068 96.8054H88.4495L86.1519 57.7138L86.0338 55.7383H83.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    opacity: 0.2,
    d: "M86.0338 55.7383H83.8516L83.9992 57.6172H86.1519L86.0338 55.7383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M87.178 56.7021L39.7333 56.7021C39.6572 56.7021 39.5818 56.6872 39.5115 56.658C39.4411 56.6289 39.3772 56.5862 39.3234 56.5323C39.2695 56.4785 39.2268 56.4146 39.1977 56.3442C39.1686 56.2739 39.1536 56.1985 39.1536 56.1224V54.6434L87.7578 54.6434V56.1224C87.7578 56.1985 87.7428 56.2739 87.7137 56.3442C87.6845 56.4146 87.6418 56.4785 87.588 56.5323C87.5342 56.5862 87.4703 56.6289 87.3999 56.658C87.3296 56.6872 87.2542 56.7021 87.178 56.7021Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    opacity: 0.4,
    d: "M87.178 56.7021L39.7333 56.7021C39.6572 56.7021 39.5818 56.6872 39.5115 56.658C39.4411 56.6289 39.3772 56.5862 39.3234 56.5323C39.2695 56.4785 39.2268 56.4146 39.1977 56.3442C39.1686 56.2739 39.1536 56.1985 39.1536 56.1224V54.6434L87.7578 54.6434V56.1224C87.7578 56.1985 87.7428 56.2739 87.7137 56.3442C87.6845 56.4146 87.6418 56.4785 87.588 56.5323C87.5342 56.5862 87.4703 56.6289 87.3999 56.658C87.3296 56.6872 87.2542 56.7021 87.178 56.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    opacity: 0.2,
    d: "M39.1536 55.6709L87.7578 55.6709V54.6402L39.1536 54.6402V55.6709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M38.1371 54.9095H88.7787C88.8549 54.9099 88.9304 54.8951 89.0009 54.8661C89.0714 54.8371 89.1355 54.7944 89.1894 54.7405C89.2433 54.6866 89.286 54.6226 89.315 54.5521C89.344 54.4816 89.3588 54.406 89.3584 54.3298C89.3584 54.176 89.2973 54.0285 89.1886 53.9198C89.0799 53.8111 88.9324 53.75 88.7787 53.75H38.1371C37.9831 53.75 37.8354 53.811 37.7262 53.9196C37.6171 54.0283 37.5554 54.1758 37.5547 54.3298C37.5547 54.4061 37.5698 54.4817 37.5991 54.5523C37.6284 54.6228 37.6713 54.6868 37.7254 54.7407C37.7796 54.7946 37.8438 54.8372 37.9145 54.8662C37.9851 54.8952 38.0608 54.9099 38.1371 54.9095Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    opacity: 0.4,
    d: "M38.1371 54.9095H88.7787C88.8549 54.9099 88.9304 54.8951 89.0009 54.8661C89.0714 54.8371 89.1355 54.7944 89.1894 54.7405C89.2433 54.6866 89.286 54.6226 89.315 54.5521C89.344 54.4816 89.3588 54.406 89.3584 54.3298C89.3584 54.176 89.2973 54.0285 89.1886 53.9198C89.0799 53.8111 88.9324 53.75 88.7787 53.75H38.1371C37.9831 53.75 37.8354 53.811 37.7262 53.9196C37.6171 54.0283 37.5554 54.1758 37.5547 54.3298C37.5547 54.4061 37.5698 54.4817 37.5991 54.5523C37.6284 54.6228 37.6713 54.6868 37.7254 54.7407C37.7796 54.7946 37.8438 54.8372 37.9145 54.8662C37.9851 54.8952 38.0608 54.9099 38.1371 54.9095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M77.8969 53.7449V52.8377H78.5062L77.8969 52.4834H78.3532L77.7439 52.0861H77.1668V51.6298H77.8379L77.1668 51.3641V50.3737H77.8379V49.7268H78.5062L77.8379 49.5013V49.0397H78.3156L77.9238 48.6505L77.5855 48.3096H67.2141V48.7739H66.5296L67.2919 49.1175V49.5013H65.8935V50.2153H65.2734L65.8935 50.5267V51.3238H66.3337V51.705H67.2141V52.8377H66.7202L67.1255 53.243V53.7503L77.8969 53.7449Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    opacity: 0.7,
    d: "M77.8969 53.7449V52.8377H78.5062L77.8969 52.4834H78.3532L77.7439 52.0861H77.1668V51.6298H77.8379L77.1668 51.3641V50.3737H77.8379V49.7268H78.5062L77.8379 49.5013V49.0397H78.3156L77.9238 48.6505L77.5855 48.3096H67.2141V48.7739H66.5296L67.2919 49.1175V49.5013H65.8935V50.2153H65.2734L65.8935 50.5267V51.3238H66.3337V51.705H67.2141V52.8377H66.7202L67.1255 53.243V53.7503L77.8969 53.7449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    opacity: 0.1,
    d: "M77.8966 53.7449V52.8377H78.5059L77.8966 52.4834H78.3529L77.7436 52.0861H77.1665V51.6298H77.8375L77.1665 51.3641V50.3737H77.8375V49.7268H78.5059L77.8375 49.5013V49.0397H78.3153L77.9234 48.6505L77.5852 48.3096H72.123V48.7739H71.4385L72.1982 49.1175V49.5013H70.7997V50.2153H70.1797L70.7997 50.5267V51.3238H71.2399V51.705H72.123V52.8377H71.6291L72.0317 53.243V53.7503L77.8966 53.7449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    opacity: 0.1,
    d: "M67.2891 49.5004H72.1957L67.2891 49.3232V49.5004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    opacity: 0.1,
    d: "M67.2109 51.7041H72.1202L72.1417 52.0477L67.2109 51.7041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    opacity: 0.1,
    d: "M66.3359 51.3232H71.2425L66.3359 51.495V51.3232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    opacity: 0.1,
    d: "M67.2109 52.8371H72.1202L67.2109 52.6572V52.8371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    opacity: 0.1,
    d: "M67.125 53.2422H72.0316V53.4301L67.125 53.2422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    opacity: 0.1,
    d: "M65.8906 50.2153H70.7972L65.8906 50.0596V50.2153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    opacity: 0.1,
    d: "M67.2109 48.7733H72.1202L67.2109 48.6016V48.7733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    opacity: 0.1,
    d: "M77.8384 49.0391H72.8594L77.8384 49.1921V49.0391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    opacity: 0.1,
    d: "M72.1953 49.501H77.8347L72.7214 49.6674L72.1953 49.501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    opacity: 0.1,
    d: "M70.8047 50.2148L77.8425 50.3732V50.2148H70.8047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    opacity: 0.1,
    d: "M70.8047 50.5264H74.286L70.8047 50.6955V50.5264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    opacity: 0.1,
    d: "M77.1685 51.3639L72.125 51.3237L77.1685 51.2109V51.3639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    opacity: 0.1,
    d: "M77.166 51.6289H72.0312L77.166 51.8007V51.6289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    opacity: 0.1,
    d: "M77.8937 52.4824H72.1953V52.6569L77.8937 52.4824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    opacity: 0.1,
    d: "M77.8938 52.8369H73.7656L77.8938 52.9523V52.8369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M64.6926 52.5742V53.4358C64.6926 53.6559 64.4242 53.7472 64.2121 53.7472H47.0015C46.7814 53.7472 46.5156 53.6559 46.5156 53.4358V52.5742H64.6926Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    opacity: 0.4,
    d: "M64.6926 52.5742V53.4358C64.6926 53.6559 64.4242 53.7472 64.2121 53.7472H47.0015C46.7814 53.7472 46.5156 53.6559 46.5156 53.4358V52.5742H64.6926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    opacity: 0.2,
    d: "M64.6898 52.5742V53.4358C64.6898 53.6559 64.4214 53.7472 64.2093 53.7472H52.8581C52.638 53.7472 52.375 53.6559 52.375 53.4358V52.5742H64.6898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M67.5741 43.6307L65.5234 52.9258C65.4881 53.0767 65.4035 53.2114 65.2829 53.3087C65.1623 53.406 65.0127 53.4601 64.8578 53.4627H53.6676C53.598 53.4611 53.5297 53.4435 53.468 53.4111C53.4063 53.3788 53.353 53.3326 53.3122 53.2762C53.2713 53.2197 53.2441 53.1546 53.2327 53.0859C53.2212 53.0172 53.2259 52.9468 53.2462 52.8802L55.2915 43.6575C55.3335 43.5168 55.4224 43.3947 55.5436 43.3116C55.6648 43.2285 55.8107 43.1896 55.9572 43.2012H67.15C67.4506 43.1905 67.6385 43.3274 67.5741 43.6307Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    opacity: 0.4,
    d: "M67.5706 43.6309L65.52 52.926C65.4847 53.0769 65.4 53.2116 65.2794 53.3089C65.1588 53.4061 65.0092 53.4603 64.8543 53.4628H54.0426C53.973 53.4613 53.9047 53.4437 53.843 53.4113C53.7813 53.379 53.728 53.3327 53.6872 53.2763C53.6463 53.2199 53.6191 53.1548 53.6077 53.0861C53.5962 53.0174 53.6009 52.947 53.6212 52.8804L55.6692 43.6577C55.7107 43.5167 55.7996 43.3943 55.9208 43.3111C56.0421 43.228 56.1883 43.1893 56.3349 43.2014H67.1465C67.4472 43.1907 67.6351 43.3276 67.5706 43.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    opacity: 0.2,
    d: "M62.0531 48.3547C62.0531 49.1599 61.1996 49.7961 60.5742 49.7961C59.9488 49.7961 59.5783 49.1492 59.7689 48.3547C59.9595 47.5602 60.5742 46.9402 61.1808 46.916C61.0036 47.7213 61.3848 48.3547 62.0075 48.3547H62.0531Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRafiki);
export default __webpack_public_path__ + "static/media/rafiki.2ac2b6f89eb0e2d661f03439fad12433.svg";
export { ForwardRef as ReactComponent };